import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import CardNetworks from './cardNetworks.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='googlePay' subtitle='object' mdxType="Item">
	Options for using Google Pay as a payment method.
	<Group summary='Properties' mdxType="Group">
		<Item title='captureBillingAddress' subtitle='boolean' mdxType="Item">
			Whether to prompt the user to select a billing address.
		</Item>
	</Group>
    </Item>
    <Item title='applePay' subtitle='object' mdxType="Item">
	Options for using Apple Pay as a payment method.
	<Group summary='Properties' mdxType="Group">
		<Item title='captureBillingAddress' subtitle='boolean' label='Deprecated' mdxType="Item">
			Whether to display a prompt for the user to enter their billing address during the payment process.
		</Item>
		<Item title='billingOptions' subtitle='object' mdxType="Item">
			Billing contact configuration options for Apple Pay.
			<Group summary='Properties' mdxType="Group">
				<Item title='requiredBillingContactFields' subtitle='("postalAddress" | "phoneNumber" | "emailAddress")[]' label='required' mdxType="Item">
					An array of string values that specify which required contact information fields should be collected during the checkout process.
				</Item>
			</Group>
		</Item>
		<Item title='shippingOptions' subtitle='object' mdxType="Item">
			Shipping contact configuration options for Apple Pay.
			<Group summary='Properties' mdxType="Group">
				<Item title='requiredShippingContactFields' subtitle='("postalAddress" | "name" | "phoneNumber" | "emailAddress")[]' label='required' mdxType="Item">
					An array of string values that specify which required contact information fields should be collected during the checkout process.
				</Item>
			</Group>
		</Item>
	</Group>
    </Item>
    <Item title='allowedCardNetworks' subtitle='CardNetwork[]' label='Deprecated' mdxType="Item">
  <CardNetworks mdxType="CardNetworks" />
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      